exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".darken-60[data-v-6b18b1cd] {\n  background: rgba(0, 0, 0, 0.3);\n}\n.slider-text[data-v-6b18b1cd] {\n  padding-left: 105px;\n}\n@media (max-width: 650px) {\n.slider-text[data-v-6b18b1cd] {\n    padding: 0 80px;\n}\n.slider-text h2[data-v-6b18b1cd] {\n    font-size: 40px !important;\n}\n.slider-text h3[data-v-6b18b1cd] {\n    font-size: 20px !important;\n    font-weight: bold !important;\n}\n}\n@media (max-width: 400px) {\n.slider-text[data-v-6b18b1cd] {\n    padding: 0 65px;\n}\n}", ""]);

// exports
